<script lang="ts">
import FicheSimulation from '@/generated/fiches/FicheSimulation.vue';
import Simulation, { StatSimu } from '@/generated/classes/Simulation';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FicheSimulation,
  data() {
    const simuSelected: StatSimu = new StatSimu;

    return {
      simuSelected
    };
  },
  computed: {
    selectedSimulation(): Simulation {
      return this.simuSelected as unknown as Simulation;
    }
  },
  methods: {
    simulationUpdated(simulation: Simulation) {
      this.simuSelected = simulation as unknown as StatSimu
    }
  }
})

</script>
